(function () {
  'use strict';

  var selector = '[data-fb-delivery-estimate]';
  var timeZone = 'Australia/Brisbane';

  function goldCoastToday() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    return new Date(Date.UTC(values.year, values.month - 1, values.day, 12));
  }

  function addBusinessDays(start, count) {
    var date = new Date(start.getTime());
    var added = 0;

    while (added < count) {
      date.setUTCDate(date.getUTCDate() + 1);
      var day = date.getUTCDay();
      if (day !== 0 && day !== 6) added += 1;
    }

    return date;
  }

  function formatRange(start, end) {
    var formatter = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'UTC',
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });

    /* v2.64: "Wed 21 Oct to Mon 2 Nov". One rule everywhere: the product page, cart drawer and
       cart page all pass dispatch + standard transit days from snippets/frenly-shipping-facts.liquid. */
    return formatter.format(start) + ' to ' + formatter.format(end);
  }

  function update(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = [];

    if (scope.matches && scope.matches(selector)) nodes.push(scope);
    Array.prototype.push.apply(nodes, scope.querySelectorAll(selector));
    if (!nodes.length) return;

    var today = goldCoastToday();

    nodes.forEach(function (node) {
      var minimum = Number(node.getAttribute('data-min-business-days')) || 3;
      var maximum = Number(node.getAttribute('data-max-business-days')) || 11;
      var range = formatRange(
        addBusinessDays(today, minimum),
        addBusinessDays(today, maximum)
      );

      /* v2.72: a row can give its own words before and after the dates (data-label, data-after), for the
         product page line "... Arrives about Wed, 28 Oct to Mon, 9 Nov." Same dates, same rule. */
      var label = (node.hasAttribute('data-label') ? node.getAttribute('data-label') : 'Est. AU delivery: ') + range + (node.getAttribute('data-after') || '');
      var textCell = node.querySelector('[data-fb-delivery-text]');

      if (textCell) {
        /* Cart drawer + PDP rows keep their icon span; only the text cell changes.
           Replacing node.textContent used to wipe the icon and drop the text into
           the 22px icon column, which rendered one word per line (v2.26 fix). */
        textCell.textContent = label;
      } else {
        var keep = [];
        Array.prototype.forEach.call(node.childNodes, function (child) {
          if (child.nodeType === 1 && child.getAttribute('aria-hidden') === 'true') keep.push(child);
        });
        node.textContent = '';
        keep.forEach(function (child) { node.appendChild(child); });
        var span = document.createElement('span');
        span.setAttribute('data-fb-delivery-text', '');
        span.textContent = label;
        node.appendChild(span);
      }
      node.setAttribute('data-fb-delivery-ready', 'true');
    });
  }

  function start() {
    update(document);

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, function (node) {
          if (node.nodeType === 1) update(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) {
      update(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
